export default class Modal 
{
    constructor() 
    {
        this.$modal = document.querySelector('.js-modal');

        if (! this.$modal) {
            return
        }

        this.$modalContent = document.querySelector('.js-modal-content');

        this.$modalClose = this.$modal.querySelector('.js-modal-close');
        this.$modalClose.addEventListener('click', this.hideDetails.bind(this));

        document.querySelectorAll('.js-open-modal').forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault();
                this.showDetails(e.currentTarget.dataset.modalContent)
            })
        })

    }
    showDetails(embed) {
        this.modalOpen = true;

        document.body.classList.add('scrolling-disabled');

        this.$modal.classList.remove('hidden');
        this.$modal.setAttribute('aria-hidden', 'false');

        this.$modalContent.innerHTML = embed
    }

    hideDetails(e) {
        e.preventDefault();

        this.$modal.classList.add('hidden');
        this.$modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('scrolling-disabled');
        this.modalOpen = false;

        this.pauseVideo()
    }

    pauseVideo() {
        this.$modalContent.firstChild.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    }
}
